module.exports = __webpack_public_path__ + "static/img/apply-normal.3a39f825.png";